// Shared Recharts theme tokens matching the §6 palette.
export const CHART = {
  accent: "#2563EB",
  positive: "#16A34A",
  warn: "#D97706",
  critical: "#DC2626",
  purple: "#7C3AED",
  grid: "#E2E8F0",
  axis: "#94A3B8",
  tick: { fontSize: 11, fill: "#64748B" },
  tickSmall: { fontSize: 10, fill: "#64748B" },
  legend: { fontSize: 12 },
} as const;
